//any type checked blueice
import { EmployeeType } from 'app/main/employees/enum/employeeType.enum';

export class EmployeeAutocompleteSearchDTO {
    constructor(
        public text: string,
        public schoolId?: string,
        public type?: EmployeeType
    ) {
        this.text = text ? text : '';
        this.schoolId = schoolId ? schoolId : null;
        this.type = type ? type : null;
    }
}
